<template>
  <SkeletonTotalCard :class="isMobile ? 'mt-2' : ''" v-if="loading" />

  <v-card v-else flat class="card-flex darkMedium--text">
    <div class="total-error">
      <Error v-if="errors.length" :errors="errors" />
    </div>
    <span class="a-title">{{ title }}</span>
    <carousel
      :class="['pa-0 corousel', isMobile ? 'mt-2' : '']"
      paginationActiveColor="#50B380"
      paginationColor="#A5B0C0"
      :paginationSize="6"
      :paginationPadding="5"
      :per-page="1"
      :autoplayTimeout="10000"
      autoplay
      :loop="true"
    >
      <slide v-for="(slideMeasurement, i) in slideMeasurements" :key="i">
        <div
          v-if="slideMeasurement.length"
          :class="{
            'add-padding': showAlarms,
          }"
        >
          <div class="item" :style="defineItemHeight" v-if="plantsOnline !== '' && i == 0">
            <p class="a-description a-thin">Produzindo</p>
            <span class="a-realtime mr-1">{{ plantsOnline }}</span>
          </div>
          <div
            class="item"
            :style="defineItemHeight"
            v-for="(item, i) in slideMeasurement"
            :key="item.name + i"
          >
            <p class="a-description a-thin">{{ item.description }}</p>
            <tooltip-constant :data="item" typeMeasure="Sum Realtime">
              <template #description>
                <span
                  >This value was obtained by summing the values<br />
                  of the realtime measurements of plants.</span
                >
              </template>
              <span class="a-realtime"
                >{{ item.getValue() }} <span class="a-description">{{ item.eu }}</span></span
              >
            </tooltip-constant>
          </div>
        </div>
        <div v-else-if="errors.length" class="pl-1">
          <div v-for="i in 4" :key="i" class="d-flex align-center justify-space-between a-text">
            <span>-</span>
            <span>- -</span>
          </div>
        </div>
      </slide>
    </carousel>
  </v-card>
</template>
<script>
import { default as ConstantMeasure } from "@/models/ConstantMeasure.js";
import { getComponent } from "@/models/Component.js";
import SkeletonTotalCard from "./SkeletonTotalCard.vue";
import { mapGetters } from "vuex";
import Error from "@/components/Error/error.vue";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "TotalCard",
  props: {
    plants: Array,
  },
  components: {
    SkeletonTotalCard,
    Error,
    Carousel,
    Slide,
  },
  data: () => ({
    component: null,
    options: {
      feature_name: "Portfolio",
      name: "TotalCard",
      power: "power",
      energy: "energyDay",
      alarmName: "state", // define plants online
      measurementsNames: [],
    },
    interval: {
      instance: null,
      step: 200,
      time: 100,
      max: 7000,
    },
    alarms: [],
    measurements: [],
    powerList: [],
    energyList: [],
    errors: [],
    loading: true,
    slideMeasurements: [],
  }),
  watch: {
    plants: {
      // immediate: true,
      handler() {
        if (this.plants) {
          this.loading = true;
          clearInterval(this.interval.instance);
          this.interval.time = 200;
          this.start();
        }
      },
    },
  },
  computed: {
    ...mapGetters(["showAlarms"]),
    title() {
      if (this.component) {
        return this.component.description;
      }
      return "Total";
    },
    plantsOnline() {
      if (!this.alarms.length) return "";
      const { alarmName } = this.options;
      /*
      Count only alarms that is not Acted
      and that received a valid value from broker,
      that means that undefined is also not counted
     */
      let stateActed = this.alarms.filter(
        (alarm) => alarm.name == alarmName && !alarm.isActed() && alarm.value !== undefined
      );
      return stateActed && stateActed.length ? stateActed.length : 0;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    defineItemHeight() {
      if (!this.loading)
        return {
          "min-height":
            this.slideMeasurements.length > 1
              ? this.showAlarms
                ? "30px"
                : "40px"
              : this.showAlarms
              ? "40px"
              : "45px",
        };
      return;
    },
  },
  methods: {
    async start() {
      try {
        await this.fetchComponent();
        await this.fetchMeasurements();
        const { realtimeMeasures, alarms } = this.component;
        this.alarms = alarms;
        this.options.measurementsNames = this.getNames(realtimeMeasures);
        this.setUpdate();
      } catch (error) {
        this.errors.push(error);
        console.error(error);
      }
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    handleMeasurements() {
      this.slideMeasurements = [];
      let min = 0;
      let max = 4;
      let num = 5; // number of measurements per page in slide
      if (this.showAlarms) {
        max = 3;
        num = 4;
      }
      let numOfInterations = parseInt(this.measurements.length / num);
      for (let i = 0; i <= numOfInterations; i++) {
        this.slideMeasurements.push(this.measurements.slice(min, max));
        min = max;
        max += num;
      }
    },
    async fetchComponent() {
      const { feature_name, name } = this.options;
      this.component = await getComponent({ feature_name, name });
      if (!this.component) {
        throw `Component with feature_name ${feature_name} and name ${name} were not found`;
      } else {
        this.component.connectMQTT();
      }
    },
    async fetchMeasurements() {
      const ids = this.plants;
      await this.component.setRealtime({ plants: ids, source: "plant" });
      await this.component.setAlarms({ plants: ids });
      this.component.unsubscribe();
      this.component.subscribe();
      const { realtimeMeasures } = this.component;
      if (!realtimeMeasures) {
        throw "Realtime Measurements were not found";
      }
    },
    getNames(list) {
      let names = new Set();
      list.forEach((item) => {
        names.add(item.name);
      });
      return [...names];
    },
    countConecteds(list, key) {
      let count = 0;
      list.forEach((item) => (item.name === key ? count++ : 0));
      return count;
    },
    setUpdate() {
      if (this.interval.instance) clearInterval(this.interval.instance);
      this.interval.instance = setInterval(() => {
        const { measurementsNames } = this.options;
        const { realtimeMeasures } = this.component;
        let size = measurementsNames.length;
        this.measurements = [];
        measurementsNames.forEach((name, index) => {
          const measurement = this.calculate(realtimeMeasures.filter((item) => item.name === name));
          if (this.measurements.length === size) {
            this.$set(this.measurements, index, measurement);
          } else {
            this.measurements.push(measurement);
          }
        });
        if (this.interval.time < this.interval.max) {
          this.interval.time += this.interval.step;
          this.setUpdate();
        }
        this.handleMeasurements();
      }, this.interval.time);
    },
    calculate(list) {
      let sum = 0;
      list.forEach((item) => {
        if (item && item.check()) {
          sum += item.float();
        }
      });
      let instance = new ConstantMeasure(list[0]);
      instance.multiplier = 1;
      instance.value = sum ? sum : null;
      return instance;
    },
  },
  beforeDestroy() {
    if (this.component) {
      this.component.unsubscribeMeasures();
    }
    clearInterval(this.interval.instance);
  },
};
</script>
<style scoped>
.card-flex {
  display: flex;
  flex-direction: column;
  padding: 15px 15px 0px 15px;
  margin-bottom: 0px;
  max-width: 100%;
  align-items: space-between;
  align-content: flex-start;
}
.errors {
  padding: 15px 15px 0px 15px;
  max-width: 100%;
  height: 100%;
}
.card-title {
  text-align: left;
  font-size: 16px;
  font-weight: 400;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 30px;
  margin-right: 2px;
}
p {
  margin-bottom: 2px;
}
.alarms {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.alarms > div {
  display: flex;
  justify-content: space-around;
  align-items: center;
  min-width: 40px;
}

.total-error {
  position: absolute;
  right: 5px;
  top: 5px;
}

.add-padding {
  padding-top: 12px;
}
.corousel {
  background: white;
  border-radius: 4px;
  max-width: 100%;
}
</style>
